/* Aesthesy scroll parallax for a horizontal card strip.

   Add data-aes-parallax to a scroller ([data-aes-scroller]) whose cards hold
   an image inside a clipped frame. As the strip scrolls, each card publishes
   --aes-px: its centre's offset from the strip's centre, as a fraction of the
   strip width in the range -1..1. CSS moves the image by a slice of that, so
   the picture drifts inside the frame against the card's own motion — the
   classic carousel parallax. Work is one rAF per scroll frame, transforms
   only (no layout), and nothing at all for reduced-motion users. */
(() => {
  if (window.__aesParallaxBooted) return;
  window.__aesParallaxBooted = true;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const bind = (scroller) => {
    if (scroller.dataset.aesPxBound) return;
    scroller.dataset.aesPxBound = '1';
    const cards = () => [...scroller.children];
    let raf = 0;
    const paint = () => {
      raf = 0;
      const sr = scroller.getBoundingClientRect();
      const mid = sr.left + sr.width / 2;
      cards().forEach((c) => {
        const r = c.getBoundingClientRect();
        const off = (r.left + r.width / 2 - mid) / sr.width;   // -1 .. 1 across the strip
        c.style.setProperty('--aes-px', Math.max(-1, Math.min(1, off)).toFixed(3));
      });
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(paint); };
    scroller.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  };

  const boot = () => document.querySelectorAll('[data-aes-parallax]').forEach(bind);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
